import {
  SET_ACTIVE_TAB,
  SET_EQUIPMENT,
  SET_ERROR_CODE,
  SET_CATALOGUE_SELECTIONS,
} from './types'
import {
  defaultJobTab,
  initialErrorCode,
} from '../../components/jobs/jobs.description'

const initialState = {
  activeTab: defaultJobTab,
  equipment: { selected: [], options: {} },
  errorCode: initialErrorCode,
  catalogueSelected: [],
}

const jobsReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: { ...state.activeTab, ...payload },
      }
    case SET_EQUIPMENT:
      return {
        ...state,
        equipment: { ...state.equipment, ...payload },
        // equipment: [...payload],
      }

    case SET_ERROR_CODE:
      return {
        ...state,
        errorCode: { ...state.errorCode, ...payload },
      }

    case SET_CATALOGUE_SELECTIONS:
      return {
        ...state,
        catalogueSelected: [...payload],
      }

    default:
      return state
  }
}

export default jobsReducer
